module.exports = __webpack_public_path__ + "img/bwwy.587fdb1e.png";